var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_894_6228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.69218L7 10.2563L11 5.12808M7.5 14.8717C6.58075 14.8717 5.6705 14.686 4.82122 14.3252C3.97194 13.9644 3.20026 13.4355 2.55025 12.7688C1.90024 12.1022 1.38463 11.3107 1.03284 10.4397C0.68106 9.5686 0.5 8.63501 0.5 7.69218C0.5 6.74936 0.68106 5.81577 1.03284 4.94471C1.38463 4.07366 1.90024 3.2822 2.55025 2.61552C3.20026 1.94884 3.97194 1.42 4.82122 1.0592C5.6705 0.698398 6.58075 0.512695 7.5 0.512695C9.35652 0.512695 11.137 1.2691 12.4497 2.61552C13.7625 3.96193 14.5 5.78806 14.5 7.69218C14.5 9.5963 13.7625 11.4224 12.4497 12.7688C11.137 14.1153 9.35652 14.8717 7.5 14.8717Z",
    stroke: "#4ECB71",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_894_6228",
    x: -5,
    y: -0.987305,
    width: 25,
    height: 25.3589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_894_6228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_894_6228",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVactor);
export default __webpack_public_path__ + "static/media/Vactor.db482cd004d1625c29d7d2bd274a8cef.svg";
export { ForwardRef as ReactComponent };